
    import "src/app/AppSeller/SettingsPage/Invoicing/Remittance/BankDetails/index.module.scss?farm_css_modules";
    
    export default {"bankDetails": `bankDetails-3f566eea`,"form": `form-3f566eea`,"info": `info-3f566eea`,"input": `input-3f566eea`}
    